import { Box, Flex, styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const PrimaryText = styled(Text)`
  color: #040222;
`;

export const Wrapper = styled(Box)`
  width: 100%;
  height: fit-content;
  padding: 0;
  padding-bottom: 1em;
  border-radius: 12px;
  ${(props: any) => props.styles}
  @media (min-width: 768px) {
    padding-left: 0;
    padding-bottom: 0;
    padding-top: 0;
    ${(props: any) => props.styles}
  }

`;


export const HeadingContainer = styled(Flex)`
  z-index: 0;
  width: space-between;
  justify-content: space-between
  align-items: center;
  background-color: #F9F6FF;
  box-sizing: border-box;
  padding:   1rem 1rem 0.75rem 1rem;
  ${(props) => props.styles};
`;

export const Heading = styled(Text)`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #040222;
  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const CouponCardWrapper = styled.div`
    padding: 12px 16px 16px 16px;
`

export const CouponContainer = styled(Box)`
  padding: 1rem 1rem 1.25rem;
  box-sizing: border-box;
`;

export const TitleContainer = styled(Box)`
  padding: 1rem;
  background: #f8f7fc;
`;



export const AddCouponInputCta = styled(Text)`
  position: absolute;
  right: 1rem;
  top: calc(50%);
  transform: translateY(-50%);
  color: ${props =>
    props.couponCode && props.couponCode?.length > 0 ? "#1B73E8" : "#E0E0E8"};
  pointer: cursor;
`;

export const RemoveCouponInputContainer = styled(Flex)`
  padding: 12px 12px 12px 16px;
  border-radius: 8px;
  border: 1px solid #e7e7f0;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: border-box;
  align-items: center;
`;

export const AppliedCouponDetailsContainer = styled(Flex)`
  flex-direction: column;
  gap: 4px;
`;

export const AppliedCouponText = styled(PrimaryText)`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

export const AppliedCouponCodeDeiscountText = styled(Text)`
  color: #0b753e;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;

export const RemoveCouponCta = styled(Text)`
  color: #d83d37;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
`;

export const CouponList = styled(Flex)`
  flex-direction: column;
  gap: 24px;

  ${({ error }) => error ? "margin-top: 40px" : "margin-top: 24px"};
  
`;

export const Divider = styled(Box)`
  height: 1px;
  background: #e7e7f0;
`;

export const CouponApppliedText = styled(Text)`
  color: #0b753e;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;

export const ViewMoreCoupons = styled(Flex)`
  color: #36354c;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  align-items: center;
  margin: 0px auto;
  gap: 4px;
  width: max-content;
`;

